import debug from 'debug';
const log = debug('Dictionay:Api');

class Api {
	/**
	 * @param {Object} options
	 * @param {string} options.path
	 * @param {boolean} [options.includeDescendants] default value is false
	 */
	Get(options) {
		const includeDescendants = options.includeDescendants || false;
		let url = `/api/rest/dictionary/get?path=${options.path}&IncludeDescendants=${includeDescendants}`;

		if (document.body.getAttribute('data-prototype') === 'True') {
			log('host', window.location.host);
			let hostUrl = '';
			switch(window.location.host) {
				case 'test-proto.minetilbud.dk/':
					hostUrl = '//test.minetilbud.dk';
					break;
				default:
					hostUrl = '//local.minetilbud.dk';
					break;
			}

			url = hostUrl + url;
		}

		log('Get() - url', url);

		return new Promise((resolve, reject) => {
			fetch(url, {
				method: 'GET'
			}).then(response => {
				log('Get() - status, url', response.status, url);
				return response.text();
			}).then(text => {
				let dictionary = {};
				
				if (text) {
					dictionary = JSON.parse(text).dictionary;
				}
				
				log(`Get() - Available labels in '${ url }'`, dictionary);
				resolve(dictionary);
			}).catch(error => {
				log(`Get() - Error for ${ url }:` , error);
			})
		});
	}
}

export default Api;
